import { IconWrapper } from '../runtime';
export default IconWrapper('chat', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75024 3.24976C1.75024 2.42133 2.42181 1.74976 3.25024 1.74976H12.7502C13.5787 1.74976 14.2502 2.42133 14.2502 3.24976L14.25 10.7629C14.25 11.5914 13.5784 12.2629 12.75 12.2629H8.7822L6.26073 14.8168C6.0723 15.0077 5.74725 14.8742 5.74725 14.606V12.2629H3.25C2.42157 12.2629 1.75 11.5914 1.75 10.7629L1.75024 3.24976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M6 7C6 7.55228 5.55228 8 5 8C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6C5.55228 6 6 6.44772 6 7Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M9 7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M12 7C12 7.55228 11.5523 8 11 8C10.4477 8 10 7.55228 10 7C10 6.44772 10.4477 6 11 6C11.5523 6 12 6.44772 12 7Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});